export enum TeamCreditsActionEnum {
  ADD = "ADD",
  USE = "USE",
}

export enum CreditsTypeEnum {
  PHONE_RETRIEVAL = "PHONE_RETRIEVAL",
}

export enum TeamCreditsStackSourceEnum {
  PURCHASE = "PURCHASE",
  GIFT = "GIFT",
}

export const TeamCreditsStackPoolEnum = {
  MAIN: "MAIN",
  API_PUBLIC: "API_PUBLIC",
} as const;
export type TeamCreditsStackPoolEnum =
  (typeof TeamCreditsStackPoolEnum)[keyof typeof TeamCreditsStackPoolEnum];
